import { AbstractControl, ValidationErrors } from "@angular/forms";

export const VerificaNome = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || "";

  if (!value) {
    return null;
  }

  let numberCharacters = /[0-9]+/g;
  if (numberCharacters.test(value) === true) {
    return { checkName: `O nome não pode ter número` };
  }

  let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (specialCharacters.test(value) === true) {
    return {
      checkName: `O nome não pode ter caracter especial`,
    };
  }

  let hasMinLength = value.length >= 10;
  if (hasMinLength === false) {
    return { checkName: `O nome precisa te no mínimo 10 caracteres` };
  }

  return null;
};
export const ValidarNomePessoa = function (control: any): any | null{
  const inputValor = control.target.value;
  const regexNome = /^[a-zA-ZÀ-ÿ\u00C0-\u017F' -]+$/;

  // Verifica se o valor do campo passa na validação da expressão regular
  if (!regexNome.test(inputValor)) {
    // Se não passar, remove os caracteres inválidos do valor do campo
    control.target.value = inputValor.replace(/[^a-zA-ZÀ-ÿ\u00C0-\u017F' -]+/g, '');
  }

}